import {z} from 'zod';

export const giftCardEntrySchema = z.object({
  number: z.string().min(1, 'Gift Card Number is required'),
  pin: z.string().min(1, 'PIN is required'),
});

export type GiftCardEntryFormData = z.infer<typeof giftCardEntrySchema>;
